import React, { useEffect, useState } from "react";
import { Tabs, Tab, Paper, useTheme } from "@mui/material";

const CustomTabs = ({
  tabs,
  initialTab = tabs?.[0]?.value,
  selectedTab,
  onChange,
  showContent = true,
  style = {},
  extraProps = {},
}) => {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState(selectedTab || initialTab);

  useEffect(() => {
    if (selectedTab) {
      setTabValue(selectedTab);
    }
  }, [selectedTab]);

  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
    onChange?.(newValue);
  };

  return (
    <>
      <Paper
        square
        elevation={0}
        style={{
          position: "relative",
          top: "1px",
          zIndex: 1000,
          backgroundColor: "#F5F5F5",
          ...style?.container,
        }}
        {...extraProps?.container}
      >
        <Tabs
          value={tabValue}
          onChange={handleChange}
          indicatorColor="secondary"
          TabIndicatorProps={{
            style: {
              top: 0,
              border: "none",
              borderBottom: "none",
              ...style?.indicator,
            },
            ...extraProps?.indicator,
          }}
          textColor="secondary"
          style={style?.tabs}
          sx={{
            "& .MuiTab-root:not(.Mui-selected)": {
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.07) !important",
              },
            },
          }}
          {...extraProps?.tabs}
        >
          {tabs?.map(({ label, value, hide }) => {
            const activeTab = value === tabValue;
            return (
              <Tab
                key={value}
                value={value}
                label={label}
                style={{
                  fontWeight: 500,
                  border: activeTab ? "1px solid #E0E0E0" : "none",
                  borderBottom: activeTab
                    ? theme.palette.background.paper
                    : "none",
                  display: hide ? "none" : "block",
                  backgroundColor: activeTab
                    ? theme.palette.background.paper
                    : "transparent",
                  ...style?.tab,
                }}
                {...extraProps?.tab}
              />
            );
          })}
        </Tabs>
      </Paper>

      {showContent && (
        <div style={{ marginBottom: "10px", ...style?.content }}>
          {tabs.find((tab) => tab.value === tabValue)?.component}
        </div>
      )}
    </>
  );
};

export default CustomTabs;
